import React from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import styles from "../ModalHelpDialog/ModalHelpDialog.module.scss";

export type ModalDialogProps = {
  showDialog: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

const ModalVirusDialog: React.FC<ModalDialogProps> = ({ showDialog, handleClose, handleConfirm }) => {
  return (
    <Modal show={showDialog} onHide={handleClose} centered dialogClassName={styles.modal80w}>
      <Modal.Header closeButton className="px-4">
        <Modal.Title>Es wurden Viren gefunden</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Row>
          <Col>Einige Ihrer Dateien enthalten Viren.</Col>
        </Row>
        <Row>
          <Col>Wenn Sie die Anfrage dennoch abschicken wollen, werden diese Dateien in Ihrer Anfrage ignoriert.</Col>
        </Row>
        <Row>
          <Col>Sie können auch zu den Dateien zurückkehren und diese austauschen.</Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="px-4 d-flex justify-content-between">
        <Button className="secondary" onClick={handleConfirm}>
          Dennoch abschicken
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalVirusDialog;
